/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import Layout from "./Layout/Layout";
import LoginPage from "./Layout/Login";
import NotFound from "./Layout/NotFound";
import * as gtmUtils from "./commons/gtmUtils.js";
import FullRedaction from "./components/FullRedaction/FullRedaction";
import authProvider from "./providers/authProvider";
import dataProvider from "./providers/dataProvider";
import { planReducer } from "./reducers/planReducer";
import { userProfileReducer } from "./reducers/userProfileReducer";
import { customRoutes, resources } from "./routes/index";
import { createBrowserHistory } from "history";
import { Admin } from "react-admin";
import { ErrorBoundary } from "react-error-boundary";
import { Route } from "react-router-dom";

const history = createBrowserHistory();

const App = () => {
  history.listen((location) => {
    gtmUtils.dispatchGtmEvent("page_view", location.pathname);
  });
  function ErrorFallback({error}) {
    return (
      <div role="alert">
        <div>An unexpected error occurred. Please contact our support team if you need further assistance.</div>
        <div>{error}</div>
      </div>
    )
  }
  return (
    <>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
      >
        <Admin
          disableTelemetry
          catchAll={NotFound}
          layout={Layout}
          loginPage={LoginPage}
          logoutButton={null}
          authProvider={authProvider}
          dataProvider={dataProvider}
          dashboard={FullRedaction}
          history={history}
          customReducers={{
            userProfile: userProfileReducer,
            userPlan: planReducer,
          }}
          customRoutes={customRoutes.map((route) => (
            <Route
              exact
              key={route.key}
              path={route.path}
              component={route.component}
              noLayout={route.noLayout ?? false}
            />
          ))}
          className="App"
        >
          {resources.map((resource) => resource)}
        </Admin>
      </ErrorBoundary>
    </>
  );
};

export default App;
